import { formatMultipleSortingForEndpoint } from '@app/components/data-table/lib/parsers';
import { useGroupFilters } from '@app/group/hooks/use-group-filters';
import { usePeriodDateRange } from '@app/group/hooks/use-period-date-range';
import { useDataTableQueryState } from '@app/hooks/use-data-table-query-state';
import { useGetGroupFoodAndDrink } from '@shared/api/hooks/group/food-and-drink';
import {
  GroupFoodAndDrinkListEmissionsCategoryItem,
  GroupFoodAndDrinkListFamilyItem,
  GroupFoodAndDrinkListSortItem,
} from '@shared/api/types';
import { parseAsArrayOf, parseAsString, useQueryState } from 'nuqs';
import GroupPage from '../components/group-page';
import GroupFoodAndDrinkTable from '../components/tables/group-food-and-drink-table';

export default function GroupFoodAndDrinkPage() {
  const { page, perPage, sort } = useDataTableQueryState();
  const [name] = useQueryState('name', parseAsString);
  const [rating] = useQueryState(
    'rating',
    parseAsArrayOf(parseAsString).withDefault([])
  );
  const [family] = useQueryState(
    'family',
    parseAsArrayOf(parseAsString).withDefault([])
  );
  const [supplier] = useQueryState(
    'supplier',
    parseAsArrayOf(parseAsString).withDefault([])
  );

  const [{ orgs }] = useGroupFilters();
  const { start, end } = usePeriodDateRange();

  const data = useGetGroupFoodAndDrink({
    page,
    page_size: perPage,
    sort: formatMultipleSortingForEndpoint(
      sort ?? []
    ) as GroupFoodAndDrinkListSortItem[],
    organizations: orgs.length ? orgs : undefined,
    dateStart: start ?? undefined,
    dateEnd: end ?? undefined,
    search: name || undefined,
    emissionsCategory: rating.length
      ? (rating as GroupFoodAndDrinkListEmissionsCategoryItem[])
      : undefined,
    family: family.length
      ? (family as GroupFoodAndDrinkListFamilyItem[])
      : undefined,
    suppliers: supplier.length ? supplier : undefined,
  });

  const count = data.data?.count ?? 0;
  const pageCount = Math.ceil(count / (perPage || 10));

  if (data.isError) throw new Error('Failed to load group food and drink');

  return (
    <GroupPage pageKey="purchasingFoodAndDrink">
      <GroupFoodAndDrinkTable {...data} pageCount={pageCount} />
    </GroupPage>
  );
}
